import { Component, OnInit } from '@angular/core';
import { randomInt } from 'crypto';

@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.css']
})
export class SpinnerComponent implements OnInit {
  iSource=""
  constructor() { }

  ngOnInit(): void {
    let ii=Math.floor(Math.random()*7)
    this.iSource="/assets/images/loading/l"+ii+".gif"
  }

}
